import React, { Component } from "react";
import "babel-polyfill";
import AliBar from "./components/alibar";
import SearchCategory from "./components/searchCompoent";
import "../../scss/index.scss";
import offerModule from "../../module/index";
import headModule from "../../module/header";
import guuessModule from "../../module/guess";
import mkcModule from "../../module/mkc";
//import FooterModule from "./components/footer";
import FooterModule from "./newComponents/footer";
import LeadLogin from "./components/leadLogin";
import service from "../../service/index";
import $ from "jquery";
import goldlog from "@ali/goldlog";
import { Feedback } from "@alife/next";
import Newheader from "./newComponents/header";
// import SearchCategorySticky from "./newComponents/searchCompoentSticky";
import ZrList from "./components/zrList";
import ZrGuess from "./components/zrGuess";
import { loadJs } from "../util/loadJs";
import SEMPINZ from "./components/sempinz";
import { registerModule, registerService, start } from "@alife/tarot";
// import SEMPINZ from "@alife/ocms-fusion-1688-pc-cate1688-pc-widget";

const Toast = Feedback.toast;

const getExpParams = (exp) => {
  let res = {};
  let configs = exp.split(";");
  configs.map((configStr) => {
    let key = configStr.split(":")[0];
    let val = configStr.split(":")[1];
    res[key] = val;
  });
  return res;
};


// JSTracker 
window.g_config = window.g_config || {};
window.g_config.jstracker2 = window.g_config.jstracker2 || {};
window.g_config.jstracker2.pid = '24416-tracker';
Object.assign(window.g_config.jstracker2, {p_sampling: 100});
loadJs(`//g.alicdn.com/tb/tracker/index.js`)

// 旺旺
loadJs(`https://g.alicdn.com/aliww/ww-light-cbu/index.js?t=${Date.now()}`);

class Main extends Component {
  state = {
    width: 1190,
    visibleTopBar: false,
  };

  constructor(opts) {
    super(opts);

    this.receviceMessage = this.receviceMessage.bind(this);

    this.state = {
      showPz: true,
    };
  }

  componentDidMount() {
    const self = this;
    const sizeFun = function () {
      const _width = document.body.clientWidth;
      if (_width < 1190) {
        self.setState({
          width: 990,
        });
      } else if (_width >= 1190 && _width < 1390) {
        self.setState({
          width: 1190,
        });
      } else {
        self.setState({
          width: 1390,
        });
      }
    };
    sizeFun();
    window.onresize = function () {
      let res;
      if (res) {
        clearTimeout(res);
      }
      res = setTimeout(() => {
        sizeFun();
      }, 20);
    };
    //滚动
    const sizeFun2 = function () {
      const _height = $(window).scrollTop();
      if (_height > 200) {
        if (!self.state.visibleTopBar) {
          self.setState((preState) => ({
            ...preState,
            visibleTopBar: true,
          }));
        }
      } else {
        if (self.state.visibleTopBar) {
          self.setState((preState) => ({
            ...preState,
            visibleTopBar: false,
          }));
        }
      }
    };
    $(window).scroll(() => {
      sizeFun2();
    });
    //配置
    window.__WPO.setConfig({
      sample: 1, // 抽样率，100 = 1%，1 = 100%，默认100
    });

    window.__WPO.log(`referrer_${p4pObject.cosite}`, 1);
    goldlog.record(
      "/szyx.pc_sem.referrer",
      "EXP",
      `ref=${p4pObject.cosite}`,
      "GET"
    );

    if (pageConfig.listOffer.length === 0) {
      const ref =
        document.referrer.indexOf(window.location.host) === -1
          ? "external"
          : "location";
      window.__WPO.log(
        `empty_${pageConfig.keywords}_${p4pObject.cosite}_${p4pObject.cosite}`,
        1
      );
      goldlog.record(
        "/szyx.pc_sem.empty",
        "EXP",
        `souce=${p4pObject.cosite}&ref=${ref}&keyword=${pageConfig.keywords}`,
        "GET"
      );
    }

    //
    window.addEventListener("message", this.receviceMessage, false);
  }

  receviceMessage(e) {
    try {
      const { type, action } = e.data;
      if (type === "ds_creative" && action === "remove") {
        this.setState({
          showPz: false,
        });
      }
    } catch (err) {
      console.error(err);
      this.setState({
        showPz: false,
      });
    }
  }
  render() {
    const list = pageConfig.relativeWords || [];
    const listJSON = list;
    const { listOffer, exp } = pageConfig;
    let expParams = getExpParams(exp || "");
    console.log(expParams);

    return (
      <div className="app" id="app">
        <div>
          <AliBar width={this.state.width} />
          <Newheader width={this.state.width} />
          {this.state.showPz ? <SEMPINZ width={this.state.width} /> : ""}
          <SearchCategory list={listJSON} width={this.state.width} expParams={expParams} />
          <ZrList width={this.state.width} listOffer={listOffer} />
          <ZrGuess width={this.state.width} />
          <FooterModule width={this.state.width} />
        </div>
      </div>
    );
  }
}

registerService(service);
// 注册公共module
registerModule([offerModule, headModule, guuessModule, mkcModule]);

start("app", {
  root: <Main />,
  puck: {
    schema: {
      // 判断业务上是否成功
      isSuccess(res) {
        if (res.info && !res.info.ok) {
          const { code } = res.info;
          switch (code) {
            default:
              Toast.error(res.info.message || "服务器响应失败,请稍后再试!");
              break;
          }
        } else if (res.info && res.info.ok) {
          return true;
        } else {
          return false;
        }
      },
      // 获取数据
      getData(res) {
        return res.data;
      },
    },
  },
});
